// Action 提交的是 mutation，而不是直接变更状态。
// Action 可以包含任意异步操作。
import cookie from './chat/utils/cookie'
import pageUtil from './chat/utils/page'

/* 导出actions方法 */
import api from '@/api'
import {initNimSDK, initUnreadNimSDK} from './chat/initNimSDK'
import {updateFriend, addFriend, deleteFriend} from './chat/friends'
import {resetSearchResult, searchUsers, searchTeam} from './chat/search'
import {setCurrSession, resetCurrSession} from './chat/session'
import {
    sendMsg,
    sendCustomMsg,
    sendFileMsg,
    sendDropFile,
    reSendMsg,
    sendMsgReceipt,
    sendEmojiMsg,
    sendProductCardMsg,
    sendRobotMsg,
    revocateMsg,
    getHistoryMsgs,
    resetNoMoreHistoryMsgs,
} from './chat/msgs'
import {
    delegateTeamFunction,
    onTeamNotificationMsg,
    enterSettingPage,
    getTeamMembers,
    checkTeamMsgReceipt,
    getTeamMsgReads,
} from './chat/team'

function connectNim({state, commit, dispatch}, obj) {
    let {force} = {...obj}
    // 操作为内容页刷新页面，此时无nim实例
    if (!state.nim || force) {
        let accountInfo = window.localStorage.getItem('accountInfo')
        accountInfo = JSON.parse(accountInfo) || {}
        if (!accountInfo.yunxinAccId) {
            if (!window.location.href.includes('login')) {
                pageUtil.turnPage('', 'login')
            }
        } else {
            dispatch('initNimSDK', accountInfo)
        }
    }
}

export default {
    logInFailedPrompt({commit}) {
        commit('logInFailedPrompt')
    },
    changeLocale({state, commit}, lang) {
        state.locale = lang
        commit('updateCurrSessionMsgs', {
            type: 'init',
        })
    },
    showFullScreenImg({state, commit}, src) {
        if (src) {
            let obj = {
                src,
                type: 'show',
            }
            commit('updateFullScreenImage', obj)
        }
    },
    hideFullScreenImg({state, commit}) {
        commit('updateFullScreenImage', {
            type: 'hide',
        })
    },
    // 连接sdk请求，false表示强制重连
    connect(store, obj) {
        let {type} = {...obj}
        // type 可为 nim chatroom
        type = type || 'nim'
        switch (type) {
            case 'nim':
                connectNim(store, obj)
                break
            default:
                break
        }
    },

    connectUnreadNim({state, commit, dispatch}, obj) {
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}')
        api.user_yunxin_info({
            userName: userInfo.userName,
            userId: userInfo.userId,
            userSystem: 'peanut',
            identityOwner: 'manage',
            userType: 'customer_service',
        }).then(({data}) => {
                this.commit('chat/updateAccountInfo', data)
                dispatch('initUnreadNimSDK', data)
            })
    },

    // 用户触发的登出逻辑
    logout({state, commit}) {
        window.localStorage.removeItem('accountInfo')
        window.localStorage.removeItem('notificationList')
        window.localStorage.removeItem('referensh')
        window.localStorage.removeItem('changeCompany')
        window.localStorage.removeItem('noCompany')
        window.localStorage.removeItem('userCompanyInfo')
        // 云信账号退出
        if (state.nim) {
            state.nim.disconnect()
        }
        // 用户账号退出
        pageUtil.turnPage('', 'login')
    },

    // 初始化 重新连接SDK
    initNimSDK,
    initUnreadNimSDK,
    // 清空所有搜索历史纪录
    resetSearchResult,
    // 搜索用户信息
    searchUsers,
    // 更新好友
    addFriend,
    deleteFriend,
    updateFriend,
    // 设置当前会话
    setCurrSession,
    // 重置当前会话
    resetCurrSession,
    // 发送消息
    sendMsg,
    sendCustomMsg,
    sendFileMsg,
    sendDropFile,
    sendRobotMsg,
    reSendMsg,
    sendEmojiMsg,
    sendProductCardMsg,
    // 发送消息已读回执
    sendMsgReceipt,
    // 消息撤回
    revocateMsg,
    getHistoryMsgs,
    // 重置历史消息状态
    resetNoMoreHistoryMsgs,
    // 处理群消息回调
    onTeamNotificationMsg,
    // 群消息回执检查
    checkTeamMsgReceipt,
    // 查询群消息回执已读列表
    getTeamMsgReads,
}
